import { render, staticRenderFns } from "./ChavePix.vue?vue&type=template&id=4c4d5299&scoped=true&"
import script from "./ChavePix.vue?vue&type=script&lang=js&"
export * from "./ChavePix.vue?vue&type=script&lang=js&"
import style0 from "./ChavePix.vue?vue&type=style&index=0&id=4c4d5299&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4d5299",
  null
  
)

export default component.exports